const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmergencyMedicine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.6,6.3h-5.7c-0.8,0-1.4,0.6-1.4,1.4v3.7 c0,0.8,0.6,1.4,1.4,1.4h5.7c0.8,0,1.4-0.6,1.4-1.4V7.8C20.1,7,19.4,6.3,18.6,6.3z M19.2,11.4c0,0.5-0.4,0.9-0.9,0.9h-5.2 c-0.5,0-0.9-0.4-0.9-0.9V8c0-0.5,0.4-0.9,0.9-0.9h5.2c0.5,0,0.9,0.4,0.9,0.9V11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M6.4,25.2h18.8c0.6,0,1.1-0.5,1.1-1.1V10.8 c0-0.6-0.5-1.1-1.1-1.1H6.4c-0.6,0-1.1,0.5-1.1,1.1v13.3C5.3,24.7,5.8,25.2,6.4,25.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 24.4,
    cy: 11.5,
    r: 3.8
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "27,10.4 25.4,10.4 25.4,8.9 23.4,8.9 23.4,10.4 21.9,10.4 21.9,12.5 23.4,12.5 23.4,14  25.4,14 25.4,12.5 27,12.5  "
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "1.7,20.6 6.1,20.6 6.9,18.4 7.6,22.5  9.3,19.5 13.8,19.5 14.9,15.1 16.4,21.1 18.3,18.5 22.9,18.5 24.4,16.6 24.4,20.5 26.3,18.3 29.8,18.3 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyMedicine);
export default __webpack_public_path__ + "static/media/emergency_medicine.64c4f7690342383e23eecd34a77d6984.svg";
export { ForwardRef as ReactComponent };